// src/components/DateHeader.js
import React, { useContext, useEffect, useState } from "react";
import { FaClock, FaSearch } from "react-icons/fa";
import { toast } from "react-toastify";
import useAxios from "../common/hook/useAxios";
import Dropdown from "./Dropdown";
import MyModal from "./Modal";
import { AuthContext } from "../context/AuthContext";
import { getCurrentTime } from "./DataTable";
import FilterHeader from "./FilterHeader";
const DateHeader = ({
  setSelectedTemplate,
  selectedSpecimenType,
  setSelectedSpecimenType,
  selectedOrderType,
  setSelectedOrderType,
  handleUpload,
  dataTableRef,
  labs,
  orderTypesForDropdown,
  specimentTypesForDropdown,
  handleSearch,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  setError,
  error,
  selectedLab,
  setSelectedLab,
  selectedValue,
  setSelectedValue,
  handleFilter
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { user } = useContext(AuthContext); // Access user and logout from context
  const [templates, setTemplates] = useState([]);
  const [template, setTemplate] = useState();
  const { request } = useAxios();

  useEffect(() => {
    setSelectedTemplate(templates.filter((item) => item.value == template)[0]);
  }, [template]);
  useEffect(() => {
    setSelectedLab(labs[0]?.value);
  }, [labs]);
  useEffect(() => {
    setTemplate(templates[0]?.value);
  }, [templates]);

  useEffect(() => {
    if (user && selectedLab) {
      request(
        `${process.env.REACT_APP_TEMPLATES_URL}/LabTemplate/GetWithIcdAndOrderCode?sInputJSON={'PracticeID':${user?.PracticeID},LabID:${selectedLab}}`,
        {
          method: "GET",
        },
      )
        .then((data) => {
          setTemplates(
            data
              .filter((item1) => item1.labid == selectedLab)
              .map((item) => {
                return {
                  value: item.labTemplateID,
                  label: item.templateName,
                  ...item,
                };
              }),
          );
        })
        .catch(() => {
          toast.error("Error occured while fetching templates", {
            autoClose: 3000,
          });
        });
    }
  }, [selectedLab]);
  useEffect(() => {
    if (user) {
      request(
        `${process.env.REACT_APP_TEMPLATES_URL}/LabTemplate?sInputJSON={'PracticeID':${user?.PracticeID}}`,
        {
          method: "GET",
        },
      )
        .then((data) => {
          setTemplates(
            data.map((item) => {
              return {
                value: item.labTemplateID,
                label: item.templateName,
                ...item,
              };
            }),
          );
        })
        .catch(() => {
          toast.error("Error occured while fetching templates", {
            autoClose: 3000,
          });
        });
    }
  }, [modalIsOpen]);
  useEffect(() => {
    handleSearch();
  }, []);

  if (error) {
    toast.error(error);
  }
  const parseDateString = (dateString) => {
    if (!dateString) return null; // Handle empty string case
    const [year, month, day] = dateString.split("-").map(Number);
    if (isNaN(year) || isNaN(month) || isNaN(day)) return null; // Handle invalid date parts
    return new Date(year, month - 1, day); // Months are zero-based
  };
  const formatDateForInput = (date) => {
    if (!(date instanceof Date) || isNaN(date)) {
      throw new Error("The provided value is not a valid Date object.");
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  return (
    <header className="bg-blue-200 text-black p-4 flex flex-wrap items-center w-full overflow-x-auto">
      <div className="flex items-center space-x-4">
        {/* <div> */}
        <label
          htmlFor="from-date"
          className="block text-md font-medium text-white-300"
        >
          From:
        </label>
        <input
          type="date"
          id="from-date"
          value={formatDateForInput(fromDate)}
          onChange={(e) => {
            const dateString = e.target.value;
            const newDate = parseDateString(dateString);
            if (newDate) {
              setFromDate(newDate); // Update the state with Date object
              setError(""); // Clear any previous errors
            } else {
              setError("Invalid date format.");
            }
          }}
          className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
        />
        {/* </div> */}
        {/* <div> */}
        <label
          htmlFor="to-date"
          className="block text-md font-medium text-white-300"
        >
          To:
        </label>

        <input
          type="date"
          id="to-date"
          value={formatDateForInput(toDate)}
          onChange={(e) => {
            const dateString = e.target.value;
            const newDate = parseDateString(dateString);
            if (newDate) {
              setToDate(newDate); // Update the state with Date object
              setError(""); // Clear any previous errors
            } else {
              setError("Invalid date format.");
            }
          }}
          className="mt-1 block w-[200px]  px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
        />
        {/* </div> */}
        <button
          onClick={handleSearch}
          className="flex items-center bg-orange text-white py-2 px-4 rounded-md shadow-sm focus:outline-none"
        >
          <FaSearch className="mr-2" />
          Search
        </button>
        <div className="">
          <Dropdown
            items={labs}
            label={"Lab:"}
            setSelectedValue={setSelectedLab}
            isHeader={true}
          />
        </div>
        <div>
          <Dropdown
            items={orderTypesForDropdown}
            label={"Order Type:"}
            setSelectedValue={setSelectedOrderType}
            isHeader={true}
          />
        </div>
        <div>
          <Dropdown
            items={specimentTypesForDropdown}
            label={"Specimen Type:"}
            setSelectedValue={setSelectedSpecimenType}
            isHeader={true}
          />
        </div>
      </div>
      <div className=" ml-4 text-md block font-medium text-white-300">
        Collection Time
      </div>
      <div className=" m-3 p-1 w-[138px] border-white bg-white text-black border-2 flex items-center space-x-2">
        <div className="w-full">{getCurrentTime()}</div>
        <FaClock className="text-gray-500 text-xl" />
      </div>
      <div>
        <Dropdown
          items={templates}
          label={"Provider/Template:"}
          setSelectedValue={setTemplate}
          setModalIsOpen={setModalIsOpen}
          isHeader={true}
        />
      </div>
      <div className=" m-3 p-1   text-black  flex items-center space-x-2">
        <button
          onClick={() => {
            if (template) handleUpload();
            else {
              toast.error("Please select a template before Upload", {
                autoClose: 3000,
              });
            }
          }}
          className="bg-orange text-white px-4 py-2 rounded transition-colors"
        >
          Upload
        </button>
      </div>
      <div>
        <FilterHeader
          // handleSearch={handleSearch}
          specimentTypesForDropdown={specimentTypesForDropdown}
          orderTypesForDropdown={orderTypesForDropdown}
          labsForDropdown={labs}
          // setSelectedOrderType={setSelectedOrderType}
          // setSelectedSpecimenType={setSelectedSpecimenType}
          // setSelectedLab={setSelectedLab}
          dataTableRef={dataTableRef}
          // setSelectedValue={setSelectedValue}
          // selectedValue={selectedValue}
          handleFilter={handleFilter}
        />
      </div>
      {
        <MyModal
          setModalIsOpen={setModalIsOpen}
          modalIsOpen={modalIsOpen}
          labsForDropdown={labs}
          orderTypesForDropdown={orderTypesForDropdown}
          templates={templates}
          setSelectedLab={setSelectedLab}
        />
      }
    </header>
  );
};

export default DateHeader;
